import React from 'react'
import { Country } from "@eco/client"
import { Autocomplete, AutocompleteChangeReason, TextField } from "@mui/material"
import { FieldProps } from "@rjsf/core"
import { useMemo } from "react"
import { useCountryQuery } from './hooks/useCountryQuery'

/**
 * A combo that render a list of country based on Ecomundo database
 * 
 * It's value is "deId" of the country
 * if multiples, it's an array of "deId"
 * @param props 
 * @returns 
 */
export const CountryCombo = (props: FieldProps<TCountryComboData>) => {

    const uiOptions = (props.uiSchema['ui:options'] || {}) as Record<string, any>
    const { data: options, isLoading } = useCountryQuery()

    const selectedOption = useMemo(() => {
        return !uiOptions.multiple 
            ? options?.find((item) => item.deId == props.formData)
            : options?.filter((item) => (props.formData as Array<number>)?.includes(item.deId!))
    }, [options, props.formData])

    const handleChange = (e: React.SyntheticEvent<Element, Event>, value: Country | Array<Country> | null, reason: AutocompleteChangeReason) => {
        props.onChange(
            !uiOptions.multiple 
            ? (value as Country)?.deId 
            : (value as Array<Country>).map((item) => item.deId)
        )
    }

    return (
        <Autocomplete
            {...uiOptions}
            disabled={props.readonly}
            options={options || []}
            getOptionLabel={(option: Country) => `${option.deLi}`}
            value={
                (
                    uiOptions.multiple 
                    ? selectedOption as Array<Country> || []
                    : selectedOption as Country || {}
                ) as any
            }
            onChange={handleChange}
            loading={isLoading}
            renderOption={(val: React.HTMLAttributes<HTMLLIElement>, option: Country) => {
                return (
                    <li {...val} key={option.deId}>
                        <img 
                            className="float-left"
                            style={{ maxWidth: 24, marginRight: 10 }}
                            src={`https://cdn.ipregistry.co/flags/wikimedia/${option.deKe?.toLocaleLowerCase()}.png`} 
                            alt={option.deLi || ''} />
                        <span> • { option.deLi }</span>
                    </li>
                )
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        disabled: props.schema.readOnly || props.readonly
                    }}
                    label={props.schema.title}
                    placeholder={`Rechercher ...`}
                />
            )}
        />
    )
}

export type TCountryComboData = Array<number> | number | undefined
